import React, { useState } from 'react';
import NextStepsStyle from './style';
import { useSelector } from 'react-redux';
import { quoteDetailSelector } from 'src/redux/selectors/quoteDetailSelector';
import { Col, Row } from 'antd';
import { PHONE_YGT } from 'src/const/common';
import { formatPhoneNumber } from 'src/const/contain';
import { ENV } from 'src/const/evn';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalSendMessage from 'src/components/modalSendMessage';
import useIsPdfPage from 'src/hooks/useIsPdfPage';

const NextSteps: React.FC = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const isPdfPage = useIsPdfPage();

    const { id: quoteId = '', resConsultant = {} } =
        useSelector(quoteDetailSelector);
    const { telephone } = resConsultant;

    const phone = telephone || PHONE_YGT;

    const openModal = () => {
        setIsModalVisible(true);
    };

    const handleClose = () => {
        setIsModalVisible(false);
    };

    return (
        <>
            <NextStepsStyle className="box-line">
                <div className="intro-title">Next steps</div>
                <Row gutter={[16, 16]}>
                    <Col xs={24} md={8}>
                        <div className="box-step">
                            <div className="step-num">1</div>
                            <div>
                                <div className="step-title">Any questions?</div>
                                <div className="step-detail">
                                    Call me on{' '}
                                    <a className="link" href={`tel:${phone}`}>
                                        {formatPhoneNumber(phone)}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xs={24} md={8}>
                        <div className="box-step">
                            <div className="step-num">2</div>
                            <div>
                                <div className="step-title">Ready to Book?</div>
                                <div className="step-detail">
                                    <a
                                        href={`${ENV.URL_PAYMENT}/quotes/QV${quoteId}`}
                                        className="link"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Pay your deposit here
                                    </a>
                                    {' '}to secure this quote.
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xs={24} md={8}>
                        <div className="box-step">
                            <div className="step-num">3</div>
                            <div>
                                <div className="step-title">
                                    Need to amend this Quote?
                                </div>
                                <div className="step-detail">
                                    <span className={isPdfPage ? "":"link"} onClick={openModal}>
                                        Let me know what you need,
                                    </span>{' '}
                                    and I'll start working on it for you.
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </NextStepsStyle>
            <ModalSendMessage
                onClose={handleClose}
                isVisible={isModalVisible}
            />
        </>
    );
};

export default NextSteps;
